import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SiteEngineerTasksForm from './siteEngineerTasksForm';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import { getCitiesList, siteByCity, createTask } from 'services/redux/networkEngineer/action';
import {getSiteData} from "../../../services/redux/DistanceCalculator/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    siteDetails: state.NetEnggReducer.siteDetails,
    createTaskResponse: state.NetEnggReducer.createTask,
    siteDetailsList: state.leadDataReducer.siteData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic, 
            getCitiesList,
            siteByCity,
            createTask,
            getSiteData
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(SiteEngineerTasksForm);